const getUserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (error) {
    return "";
  }
};

export default {
  ownedByPartnerId: null,
  codename: "",
  contacts: [],
  awsElasticIps: [],
  description: "",
  connectivityFixedIp: false,
  proxyPtz: {
    protocol: "",
    hostname: "",
    port: 0,
  },
  place: {
    address: "",
    serverNtp: "",
    timeZone: getUserTimeZone(),
    daylightSaving: true,
    geo: {
      latitude: 0,
      longitude: 0,
    },
    name: "",
    telephone: "",
  },
  mobileBox: false,
  usuallyDisconnected: false,
  allowsConcurrentEvents: null,
  allowQod: false,
  msisdnQod: "",
};
